module.exports = __webpack_public_path__ + "img/preview-satellite.884526c5.png";